$(function() {
	// delete testimonials
	$('.delete-testimonials').click(function(){
		delete_results('/testimonials/delete', { 'label' : 'testimonials', 'container' : '.testimonials' });
		return false;
	});

	// delete feedback
	$('.delete-feedback').click(function(){
		delete_results('/feedback/delete', { 'label' : 'feedback', 'container' : '.feedback' });
		return false;
	});

	$('.delete-billing-profiles').click(function(){
		delete_results('/billing-profiles/delete', { 'label' : 'billing profiles', 'container' : '.billing-profiles' });
		return false;
	});

	// delete results
	function delete_results(ajax_delete_url, options, callback) {
		var label = options['label'];
		var container = $(options['container']);
		var callback = callback || function(){}
		
		var checks = container.find('input[type=checkbox]:checked');

		if( checks.length == 0 ) {
			alert('No ' + label + ' selected.');
			return false;
		}

		if(!confirm('Are you sure you want to delete selected ' + label + '?')) {
			return false;
		}
		
		// get the selected ids
		var ids = [];
		var trs = [];
		checks.each(function(){
			var tr = $(this).parents('tr');
			trs.push( tr );
			ids.push( tr.attr('data-id') );
		});

		$.post(ajax_delete_url, { 'ids' : ids.join(',') }, function(){
			$(trs).each(function(){ $(this).remove(); });
		});
	}

	$('.delete-errors').click(function(){
		var checks = $('.php-errors input[type=checkbox]:checked');
		if( checks.length == 0 ) {
			alert('No errors selected.');
			return false;
		}

		if(!confirm('Are you sure you want to delete selected errors ?')) {
			return false;
		}
		return true;
	});
});